import * as React from 'react';
import { PureIconContainer } from './utils/IconContainer';
var ChevronRightSmallFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_ChevronRightSmallFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 7,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.735 7.322a1.141 1.141 0 0 0-.059-.06l-3.97-3.97a.998.998 0 0 0-1.414 0c-.39.392-.39 1.025.001 1.416l3.288 3.288-3.286 3.296a1.003 1.003 0 0 0 0 1.416.997.997 0 0 0 1.413 0l3.884-3.897a1.004 1.004 0 0 0 .143-1.489Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_ChevronRightSmallFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
export default ChevronRightSmallFill;